module.exports = __webpack_public_path__ + "d533392bfb8b055b6a1748b7a9be290d.png";